export default __webpack_public_path__ + "static/media/ca-opt-in.07649acf.jpg";